import { alpha, Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function Backdrop(theme: Theme) {
	return {
		MuiBackdrop: {
			styleOverrides: {
				root: {
					background: [alpha(theme.palette.common.black, 0.55)],
					backdropFilter: 'blur(1.5px)',
					'&.MuiBackdrop-invisible': {
						background: 'transparent',
					},
				},
			},
		},
	};
}
